import { useCallback, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { FullPageLoader } from '../../components';

export const RegisterRedirect = () => {
  const { loginWithRedirect } = useAuth0();

  const handleSignUp = useCallback(async () => {
    await loginWithRedirect({
      authorizationParams: {
        prompt: 'login',
        screen_hint: 'signup',
      },
    });
  }, [loginWithRedirect]);

  useEffect(() => {
    handleSignUp();
  }, [handleSignUp]);

  return <FullPageLoader />;
};
